/* GamePerch theme interactions: header, reveals, hero parallax, AJAX backpack cart. */
(function () {
  'use strict';

  /* ---------- header: logo slides upper-right -> upper-left on scroll ---------- */
  var head = document.querySelector('.site-head');
  function onScroll() {
    if (!head) return;
    head.classList.toggle('is-scrolled', window.scrollY > 60);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- scroll reveals ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    window._revealObserver = io;
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in-view'); });
  }

  /* ---------- hero parallax ---------- */
  var parallaxZones = document.querySelectorAll('[data-parallax]');
  var fine = window.matchMedia('(pointer: fine)').matches;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (fine && !reduced) {
    parallaxZones.forEach(function (zone) {
      var bits = zone.querySelectorAll('[data-depth]');
      zone.closest('.hero').addEventListener('mousemove', function (ev) {
        var r = zone.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        bits.forEach(function (b) {
          var d = parseFloat(b.getAttribute('data-depth')) || 20;
          b.style.translate = (x * d) + 'px ' + (y * d) + 'px';
        });
      });
    });
  }

  /* ---------- product page: thumbnails + quantity ---------- */
  document.querySelectorAll('.product__thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      var gallery = t.closest('.product__gallery');
      var main = gallery ? gallery.querySelector('.product__main img') : null;
      if (!main) return;
      main.src = t.getAttribute('data-thumb');
      var ss = t.getAttribute('data-srcset');
      if (ss) { main.setAttribute('srcset', ss); } else { main.removeAttribute('srcset'); }
      var timg = t.querySelector('img');
      if (timg) main.setAttribute('alt', timg.getAttribute('alt') || '');
      gallery.querySelectorAll('.product__thumb').forEach(function (b) { b.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });
  document.querySelectorAll('[data-qty-minus],[data-qty-plus]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentElement.querySelector('input[name="quantity"], input[type="number"]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      input.value = b.hasAttribute('data-qty-minus') ? Math.max(1, v - 1) : v + 1;
    });
  });

  /* ---------- backpack cart drawer ---------- */
  var drawer = document.getElementById('Backpack');
  var veil = document.getElementById('CartVeil');
  var itemsEl = document.getElementById('BackpackItems');
  var emptyEl = document.getElementById('BackpackEmpty');
  var footEl = document.getElementById('BackpackFoot');
  var subtotalEl = document.getElementById('BackpackSubtotal');
  var countEls = document.querySelectorAll('[data-cart-count]');
  var toast = document.getElementById('Toast');
  var toastTimer = null;

  function money(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('show'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('show');
      setTimeout(function () { toast.hidden = true; }, 350);
    }, 2600);
  }
  function openDrawer() {
    if (!drawer) return;
    renderCart().finally(function () {
      drawer.hidden = false;
      veil.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('open');
        veil.classList.add('show');
      });
      document.body.style.overflow = 'hidden';
    });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    veil.classList.remove('show');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; veil.hidden = true; }, 400);
  }
  function updateCount(n) {
    countEls.forEach(function (el) {
      el.textContent = n;
      el.hidden = false;
    });
  }
  function renderCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (!itemsEl) return;
        itemsEl.innerHTML = '';
        var empty = cart.items.length === 0;
        emptyEl.hidden = !empty;
        footEl.hidden = empty;
        itemsEl.style.display = empty ? 'none' : '';
        cart.items.forEach(function (item) {
          var li = document.createElement('div');
          li.className = 'bp-item';
          li.setAttribute('role', 'listitem');
          var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)$/i, '_160x$1') + '" alt="" loading="lazy">' : '';
          li.innerHTML =
            '<a href="' + item.url + '">' + img + '</a>' +
            '<div><h3>' + item.product_title + '</h3>' +
            (item.variant_title ? '<p class="bp-item__variant">' + item.variant_title + '</p>' : '') +
            '<span class="bp-item__qty">' +
            '<button data-dec="' + item.key + '" aria-label="Decrease">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button data-inc="' + item.key + '" aria-label="Increase">+</button></span> ' +
            '<button class="bp-item__remove" data-remove="' + item.key + '">Remove</button></div>' +
            '<span class="bp-item__price">' + money(item.final_line_price) + '</span>';
          itemsEl.appendChild(li);
        });
        subtotalEl.textContent = money(cart.total_price);
      })
      .catch(function () { showToast('Could not open your backpack. Please try again.'); });
  }
  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(renderCart);
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
  document.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (veil) veil.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  if (itemsEl) {
    itemsEl.addEventListener('click', function (e) {
      var t = e.target.closest('[data-dec],[data-inc],[data-remove]');
      if (!t) return;
      e.preventDefault();
      if (t.hasAttribute('data-remove')) { changeQty(t.getAttribute('data-remove'), 0); return; }
      var key = t.getAttribute('data-dec') || t.getAttribute('data-inc');
      var qtyEl = t.parentElement.querySelector('span:nth-child(2)');
      var qty = parseInt(qtyEl.textContent, 10) || 1;
      changeQty(key, t.hasAttribute('data-dec') ? qty - 1 : qty + 1);
    });
  }

  /* ---------- AJAX add to cart (PACK IT) ---------- */
  document.querySelectorAll('form[data-add-to-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.querySelector('span').textContent : '';
      if (btn) { btn.disabled = true; btn.querySelector('span').textContent = 'Packing...'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () { showToast('Packed!'); openDrawer(); })
        .catch(function () { showToast('Something did not pack right. Please try again.'); })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.querySelector('span').textContent = original; }
        });
    });
  });

  /* initial cart count */
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCount(cart.item_count); })
    .catch(function () {});

  /* ---------- catalog: ajax filtering + infinite scroll (no page reloads) ---------- */
  (function catalogApp() {
    var grid = document.getElementById('catalog-grid');
    if (!grid) return;
    var SWAP_IDS = ['catalog-sign', 'catalog-header', 'catalog-extras', 'catalog-toolbar', 'catalog-filters', 'active-pills', 'catalog-grid', 'catalog-pagination'];
    var loading = false, loadingMore = false, infObserver = null;

    function refreshDynamic() {
      var els = document.querySelectorAll('.reveal:not(.in-view)');
      if (window._revealObserver) {
        els.forEach(function (el) { window._revealObserver.observe(el); });
      } else {
        els.forEach(function (el) { el.classList.add('in-view'); });
      }
      if (window._refreshCarousels) window._refreshCarousels();
      var pills = document.getElementById('active-pills');
      if (pills) pills.hidden = !pills.textContent.trim();
    }

    function loadUrl(url, push, scrollTop) {
      if (loading) return;
      loading = true;
      grid.classList.add('is-loading');
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('fetch failed'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          SWAP_IDS.forEach(function (id) {
            var src = doc.getElementById(id), dst = document.getElementById(id);
            if (src && dst) dst.innerHTML = src.innerHTML;
          });
          grid.classList.remove('is-loading');
          if (push) history.pushState({ catalog: true }, '', url);
          refreshDynamic();
          resetInfinite();
          if (scrollTop) {
            var sign = document.getElementById('catalog-sign');
            if (sign) sign.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          loading = false;
        })
        .catch(function () { window.location.href = url; });
    }

    function resetInfinite() {
      if (infObserver) { infObserver.disconnect(); infObserver = null; }
      var pagination = document.querySelector('#catalog-pagination .pagination');
      if (pagination) pagination.hidden = true;
      var sentinel = document.getElementById('load-more-sentinel');
      if (!sentinel || !sentinel.dataset.nextUrl || !('IntersectionObserver' in window)) return;
      infObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) loadMore(); });
      }, { rootMargin: '800px 0px' });
      infObserver.observe(sentinel);
    }

    function loadMore() {
      var sentinel = document.getElementById('load-more-sentinel');
      var g = document.getElementById('catalog-grid');
      if (!sentinel || !g || loadingMore || !sentinel.dataset.nextUrl) return;
      loadingMore = true;
      sentinel.classList.add('is-loading');
      fetch(sentinel.dataset.nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('fetch failed'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var srcGrid = doc.getElementById('catalog-grid');
          if (srcGrid) {
            var tmp = document.createElement('div');
            tmp.innerHTML = srcGrid.innerHTML;
            while (tmp.firstChild) g.appendChild(tmp.firstChild);
          }
          var srcSentinel = doc.getElementById('load-more-sentinel');
          if (srcSentinel && srcSentinel.dataset.nextUrl) {
            sentinel.dataset.nextUrl = srcSentinel.dataset.nextUrl;
            sentinel.classList.remove('is-loading');
          } else if (sentinel.parentNode) {
            sentinel.parentNode.removeChild(sentinel);
          }
          refreshDynamic();
          loadingMore = false;
        })
        .catch(function () {
          loadingMore = false;
          if (sentinel) sentinel.classList.remove('is-loading');
        });
    }

    function applyFilters() {
      var form = document.getElementById('catalog-filters-form');
      if (!form) return;
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      var url = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      loadUrl(url, true, false);
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var clearPrice = e.target.closest('[data-clear-price]');
      if (clearPrice) {
        e.preventDefault();
        var purl = new URL(window.location.href);
        Array.from(purl.searchParams.keys()).forEach(function (k) {
          if (k.indexOf('filter.v.price') === 0) purl.searchParams.delete(k);
        });
        loadUrl(purl.toString(), true, false);
        return;
      }
      var nav = e.target.closest('[data-catalog-nav]');
      if (nav) {
        e.preventDefault();
        var url = nav.getAttribute('href');
        if (nav.hasAttribute('data-preserve-params') && window.location.search) {
          url += (url.indexOf('?') === -1 ? '?' : '&') + window.location.search.substring(1);
        }
        loadUrl(url, true, nav.hasAttribute('data-scroll-top'));
        return;
      }
      var tog = e.target.closest('[data-filters-toggle]');
      if (tog) {
        var panel = document.getElementById('catalog-filters');
        if (panel) {
          var open = panel.classList.toggle('is-open');
          tog.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      }
    });

    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('#catalog-filters-form')) {
        if (e.target.matches('input[type="checkbox"]')) applyFilters();
        return;
      }
      if (e.target.matches && e.target.matches('[data-sort]')) {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        loadUrl(url.toString(), true, false);
      }
    });

    document.addEventListener('submit', function (e) {
      if (e.target.matches && e.target.matches('#catalog-filters-form')) {
        e.preventDefault();
        applyFilters();
      }
    });

    window.addEventListener('popstate', function () {
      loadUrl(window.location.href, false, false);
    });

    refreshDynamic();
    resetInfinite();
  })();
  /* ---------- affiliate outbound clicks -> GA4 ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-affiliate-click]') : null;
    if (!a) return;
    if (typeof gtag === 'function') {
      gtag('event', 'affiliate_click', {
        product: a.getAttribute('data-product') || '',
        placement: a.getAttribute('data-placement') || '',
        element: a.getAttribute('data-element') || ''
      });
    }
  });
  /* ---------- carousels: manual prev/next + dots (no autoplay) ----------
     Single mode (data-carousel="single"): transform-based slider with NO scroll
     container, so it can never capture or fight the page scroll. Multi mode
     keeps native scroll-snap for multi-card rails. */
  function initCarousel(car) {
    if (car.dataset.carouselBound) return;
    car.dataset.carouselBound = '1';
    var track = car.querySelector('[data-carousel-track]');
    if (!track || track.children.length === 0) return;
    var prev = car.querySelector('[data-carousel-prev]');
    var next = car.querySelector('[data-carousel-next]');
    var dotsWrap = car.querySelector('[data-carousel-dots]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (car.dataset.carousel === 'single') {
      var slides = Array.prototype.slice.call(track.children);
      var index = 0;
      var dots = [];
      slides.forEach(function (s) {
        s.style.transition = reduced ? 'none' : 'transform .55s cubic-bezier(.22,.8,.3,1)';
      });
      function render() {
        /* Move the slides, not the track: the track is also the overflow
           clip window, so transforming it slides the window itself off the
           section and the incoming slide can never appear. */
        slides.forEach(function (s) {
          s.style.transform = 'translateX(' + (-index * 100) + '%)';
        });
        /* Slides start clipped off-canvas, so the scroll reveal observer
           never fires for them; reveal the active slide explicitly. */
        slides[index].querySelectorAll('.reveal').forEach(function (el) {
          el.classList.add('in-view');
        });
        dots.forEach(function (d, j) {
          d.classList.toggle('is-active', j === index);
          d.setAttribute('aria-current', j === index ? 'true' : 'false');
        });
      }
      function goTo(i) {
        var n = slides.length;
        index = ((i % n) + n) % n;
        render();
      }
      if (dotsWrap) {
        slides.forEach(function (_, idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to story ' + (idx + 1));
          b.addEventListener('click', function () { goTo(idx); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }
      if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });
      car.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') goTo(index - 1);
        else if (e.key === 'ArrowRight') goTo(index + 1);
      });
      /* swipe: touch-action: pan-y (CSS) keeps vertical page scroll native */
      var startX = null;
      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) goTo(index + (dx < 0 ? 1 : -1));
      }, { passive: true });
      render();
      return;
    }

    /* multi-card rail: native scroll-snap */
    var behavior = reduced ? 'auto' : 'smooth';
    function step() {
      var slide = track.firstElementChild;
      if (!slide) return 320;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }
    function maxIndex() { return track.children.length - 1; }
    function index() {
      return Math.min(Math.max(Math.round(track.scrollLeft / step()), 0), maxIndex());
    }
    var mdots = [];
    function setDot(i) {
      mdots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    function mgoTo(i) {
      var n = maxIndex() + 1;
      i = ((i % n) + n) % n;
      track.scrollTo({ left: i * step(), behavior: behavior });
      setDot(i);
    }
    if (dotsWrap) {
      for (var i = 0; i <= maxIndex(); i++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
          b.addEventListener('click', function () { mgoTo(idx); });
          dotsWrap.appendChild(b);
          mdots.push(b);
        })(i);
      }
      setDot(0);
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; setDot(index()); });
      }, { passive: true });
    }
    if (prev) prev.addEventListener('click', function () { mgoTo(index() - 1); });
    if (next) next.addEventListener('click', function () { mgoTo(index() + 1); });
  }
  function refreshCarousels(root) {
    (root || document).querySelectorAll('[data-carousel]').forEach(initCarousel);
  }
  refreshCarousels();
  window._refreshCarousels = refreshCarousels;
})();
